import React, { FC } from 'react';
import styles from './TopSection.module.scss';

const TopSection: FC = () => {
    return (
        <div className={styles.top}>
            <div className={styles.content}>
                <div className={styles.info}>
                    <h1>
                        CMMC Readiness. FedRAMP Advisory.
                        <span className={styles.highlighted}>Built by Practitioners.</span>
                    </h1>

                    <p>
                        30+ years combined cybersecurity and compliance experience — CISSP, CISA,
                        CCP, CCA, and CISM certified. Hands-on experience across every phase of
                        FedRAMP authorization, and CMMC assessment expertise grounded in real
                        practice, not theory. vCISO, CMMC Readiness, FedRAMP Advisory, and AI
                        Governance — delivered by credentialed practitioners, not call-center
                        consultants.
                    </p>

                    <div className={styles.frameworks}>
                        <span>CMMC Level 2</span>
                        <span>FedRAMP</span>
                        <span>NIST SP 800-171</span>
                        <span>NIST SP 800-53</span>
                        <span>SOC 2</span>
                        <span>ISO 27001</span>
                        <span>ISO 42001</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopSection;